module.exports = __webpack_public_path__ + "static/media/Webinar-amico.7a9e6c88.png";